// AIDEV-NOTE: stripe-identity-refactored; Production Stripe Identity service implementation

import { BaseThirdPartyService } from '../base-service'
import type {
  IIdentityVerificationService,
  IdentityVerificationData,
  VerificationSessionApiResponse,
} from '../types'

export class StripeIdentityService
  extends BaseThirdPartyService
  implements IIdentityVerificationService
{
  constructor(apiBase: string = '/api') {
    super({
      apiBase,
      timeout: 30000, // 30 seconds
    })
  }

  async getVerificationSession(
    sessionId: string
  ): Promise<IdentityVerificationData> {
    // Call backend API endpoint
    const response = await this.fetchApi<VerificationSessionApiResponse>(
      `/v1/identity-verification/${sessionId}`
    )

    // Transform API response (snake_case) to domain model (camelCase)
    return {
      verificationSessionId: response.session_id,
      clientSecret: response.client_secret || '',
      status: response.status,
      url: response.url,
    }
  }
}
